module.exports = "<div class=\"wfs-direct-pageNotFound\">\r\n  <h3 class=\"error-message\">Oops, This Page Could Not Be Found!</h3>\r\n  <h2 class=\"error-code\">404</h2>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/page-not-found/containers/page-not-found.component.html
// module id = ./src/app/pages/page-not-found/containers/page-not-found.component.html
// module chunks = main